export type TranslationSegment =
  | string
  | {
      contexts: Array<[boolean, string]>
      default: string
    }

interface TranslationKeyConfig {
  namespace?: string
  segments: TranslationSegment[]
}

export function buildTranslationKey(config: TranslationKeyConfig): string {
  const { namespace, segments } = config

  const keyParts: string[] = []

  if (namespace) {
    keyParts.push(namespace)
  }

  for (const segment of segments) {
    if (typeof segment === 'string') {
      keyParts.push(segment)
    } else {
      const matchedContext = segment.contexts.find(([when]) => when)
      const segmentValue = matchedContext != null ? matchedContext[1] : segment.default
      keyParts.push(segmentValue)
    }
  }

  if (keyParts.length === 0) {
    return ''
  }

  if (namespace && keyParts.length > 1) {
    return `${keyParts[0]}:${keyParts.slice(1).join('.')}`
  }

  return keyParts.join('.')
}
